module.exports = __webpack_public_path__ + "static/img/coupon-model-bg1.a615092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-model-bg1.png
// module id = ODZc
// module chunks = 0